import { TextLink } from 'palette/TextLink';
import { BodyText } from 'palette/Typography';
import { FooterBlock } from './FooterBlock';
import '../styles/FooterNavigationLinks.scss';

export function FooterNavigationLinks({
    navigation,
    customClass
}) {
    return (
        <FooterBlock
            customClass={customClass}
            title={navigation.name}
        >
            <div className="react-footer-navigation-links">
                {navigation.children.map(({ navigationUrl, id, name }) => (
                    <TextLink
                        key={id}
                        isUnderlinedOnHover
                        className="react-footer-navigation-links__link"
                        href={navigationUrl}
                    >
                        <BodyText level="2">
                            {name}
                        </BodyText>
                    </TextLink>
                ))}
            </div>
        </FooterBlock>
    );
}
